// tslint:disable
/**
 * Systemadmin API
 * ALP api for system admins
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import { COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BrukerPraksisstedDto
 */
export interface BrukerPraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerPraksisstedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerPraksisstedDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerPraksisstedDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerPraksisstedDto
     */
    'epost': string;
    /**
     * 
     * @type {Array<BrukerPraksisstedtilgangDto>}
     * @memberof BrukerPraksisstedDto
     */
    'tilganger': Array<BrukerPraksisstedtilgangDto>;
    /**
     * Om brukeren har administratorrettighet på toppnivå i sin organisasjon
     * @type {boolean}
     * @memberof BrukerPraksisstedDto
     */
    'administratorToppnivaa': boolean;
    /**
     * Om brukeren er deaktivert/slettet eller utløpt
     * @type {boolean}
     * @memberof BrukerPraksisstedDto
     */
    'deaktivert': boolean;
}
/**
 * 
 * @export
 * @interface BrukerPraksisstedtilgangDto
 */
export interface BrukerPraksisstedtilgangDto {
    /**
     * Id for praksisstedet tilgangen gjelder for
     * @type {string}
     * @memberof BrukerPraksisstedtilgangDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerPraksisstedtilgangDto
     */
    'navnToppnode': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerPraksisstedtilgangDto
     */
    'navnPraksissted': string;
    /**
     * 
     * @type {BrukerrollePraksisstedDto}
     * @memberof BrukerPraksisstedtilgangDto
     */
    'rolle': BrukerrollePraksisstedDto;
}


/**
 * 
 * @export
 * @interface BrukerStudiestedDto
 */
export interface BrukerStudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerStudiestedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerStudiestedDto
     */
    'feideId': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerStudiestedDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerStudiestedDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerStudiestedDto
     */
    'epost': string;
    /**
     * 
     * @type {Array<BrukerStudiestedtilgangDto>}
     * @memberof BrukerStudiestedDto
     */
    'tilganger': Array<BrukerStudiestedtilgangDto>;
    /**
     * Om brukeren har administratorrettighet på toppnivå i sin organisasjon
     * @type {boolean}
     * @memberof BrukerStudiestedDto
     */
    'administratorToppnivaa': boolean;
    /**
     * Om brukeren er deaktivert/slettet eller utløpt
     * @type {boolean}
     * @memberof BrukerStudiestedDto
     */
    'deaktivert': boolean;
}
/**
 * 
 * @export
 * @interface BrukerStudiestedtilgangDto
 */
export interface BrukerStudiestedtilgangDto {
    /**
     * Id for studie- eller praksissted tilgangen gjelder for
     * @type {string}
     * @memberof BrukerStudiestedtilgangDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerStudiestedtilgangDto
     */
    'navnToppnode': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerStudiestedtilgangDto
     */
    'navnStudiested': string;
    /**
     * 
     * @type {BrukerrolleStudiestedDto}
     * @memberof BrukerStudiestedtilgangDto
     */
    'rolle': BrukerrolleStudiestedDto;
}


/**
 * 
 * @export
 * @interface BrukerSystemPostDto
 */
export interface BrukerSystemPostDto {
    /**
     * 
     * @type {string}
     * @memberof BrukerSystemPostDto
     */
    'foedselsnummer': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerSystemPostDto
     */
    'feideId': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerSystemPostDto
     */
    'fornavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerSystemPostDto
     */
    'etternavn': string;
    /**
     * 
     * @type {string}
     * @memberof BrukerSystemPostDto
     */
    'epost'?: string;
}
/**
 * 
 * @export
 * @interface BrukereDto
 */
export interface BrukereDto {
    /**
     * 
     * @type {Array<BrukerStudiestedDto>}
     * @memberof BrukereDto
     */
    'studiestedbrukere': Array<BrukerStudiestedDto>;
    /**
     * 
     * @type {Array<BrukerPraksisstedDto>}
     * @memberof BrukereDto
     */
    'praksisstedbrukere': Array<BrukerPraksisstedDto>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BrukerrollePraksisstedDto = {
    Administrator: 'Administrator',
    Skriverettighet: 'Skriverettighet',
    Leserettighet: 'Leserettighet'
} as const;

export type BrukerrollePraksisstedDto = typeof BrukerrollePraksisstedDto[keyof typeof BrukerrollePraksisstedDto];


/**
 * 
 * @export
 * @enum {string}
 */

export const BrukerrolleStudiestedDto = {
    Administrator: 'Administrator',
    Registrererettighet: 'Registrererettighet',
    Skriverettighet: 'Skriverettighet',
    Leserettighet: 'Leserettighet'
} as const;

export type BrukerrolleStudiestedDto = typeof BrukerrolleStudiestedDto[keyof typeof BrukerrolleStudiestedDto];


/**
 * 
 * @export
 * @interface InstitusjonerDto
 */
export interface InstitusjonerDto {
    /**
     * 
     * @type {Array<MinimalStudiestedDto>}
     * @memberof InstitusjonerDto
     */
    'institusjoner': Array<MinimalStudiestedDto>;
}
/**
 * 
 * @export
 * @interface MinimalPraksisavtaleDto
 */
export interface MinimalPraksisavtaleDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisavtaleDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisavtaleDto
     */
    'praksisavtaleNavn': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisavtaleDto
     */
    'avtalestart'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisavtaleDto
     */
    'avtaleslutt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisavtaleDto
     */
    'statusAktiv'?: string;
}
/**
 * 
 * @export
 * @interface MinimalPraksisbestillingDto
 */
export interface MinimalPraksisbestillingDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisbestillingDto
     */
    'bestillingId': string;
    /**
     * 
     * @type {boolean}
     * @memberof MinimalPraksisbestillingDto
     */
    'delt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisbestillingDto
     */
    'avtaleId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisbestillingDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisbestillingDto
     */
    'aktivitetId': string;
    /**
     * 
     * @type {number}
     * @memberof MinimalPraksisbestillingDto
     */
    'bestilling': number;
    /**
     * 
     * @type {PraksisavtaleStedBestillingspunktTypeDto}
     * @memberof MinimalPraksisbestillingDto
     */
    'bestillingsmodus': PraksisavtaleStedBestillingspunktTypeDto;
}


/**
 * 
 * @export
 * @interface MinimalPraksisbesvarelseDto
 */
export interface MinimalPraksisbesvarelseDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisbesvarelseDto
     */
    'besvarelseId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisbesvarelseDto
     */
    'bestillingId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisbesvarelseDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {number}
     * @memberof MinimalPraksisbesvarelseDto
     */
    'kapasitet'?: number;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedDto
 */
export interface MinimalPraksisstedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedDto
     */
    'kode': string;
}
/**
 * 
 * @export
 * @interface MinimalPraksisstedtilgangDto
 */
export interface MinimalPraksisstedtilgangDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedtilgangDto
     */
    'brukerId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedtilgangDto
     */
    'praksisstedId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalPraksisstedtilgangDto
     */
    'tilgangstype'?: MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum;
}

export const MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum = {
    Admin: 'admin',
    Skriv: 'skriv',
    Les: 'les'
} as const;

export type MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum = typeof MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum[keyof typeof MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum];

/**
 * 
 * @export
 * @interface MinimalStudentPraksisplassDto
 */
export interface MinimalStudentPraksisplassDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalStudentPraksisplassDto
     */
    'studentPraksisplassId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudentPraksisplassDto
     */
    'praksisbesvarelseId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudentPraksisplassDto
     */
    'studentPraksisklasseId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudentPraksisplassDto
     */
    'aktivitetId': string;
}
/**
 * 
 * @export
 * @interface MinimalStudiestedDto
 */
export interface MinimalStudiestedDto {
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedDto
     */
    'studiestedId': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedDto
     */
    'institusjonsnr': string;
    /**
     * 
     * @type {string}
     * @memberof MinimalStudiestedDto
     */
    'navn': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PraksisavtaleStedBestillingspunktTypeDto = {
    AvtaleSted: 'AvtaleSted',
    OmfattetAvtaleSted: 'OmfattetAvtaleSted'
} as const;

export type PraksisavtaleStedBestillingspunktTypeDto = typeof PraksisavtaleStedBestillingspunktTypeDto[keyof typeof PraksisavtaleStedBestillingspunktTypeDto];


/**
 * 
 * @export
 * @interface PraksisstedMedInfoDto
 */
export interface PraksisstedMedInfoDto {
    /**
     * 
     * @type {string}
     * @memberof PraksisstedMedInfoDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedMedInfoDto
     */
    'navn': string;
    /**
     * 
     * @type {string}
     * @memberof PraksisstedMedInfoDto
     */
    'kode': string;
    /**
     * Referanse til foreldre node
     * @type {string}
     * @memberof PraksisstedMedInfoDto
     */
    'eier'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PraksisstedMedInfoDto
     */
    'statusAktiv': boolean;
    /**
     * Relativt nivaa i praksisstedshierarkiet
     * @type {number}
     * @memberof PraksisstedMedInfoDto
     */
    'nivaa': number;
    /**
     * Om det er relevante endringer for praksisstedet.
     * @type {boolean}
     * @memberof PraksisstedMedInfoDto
     */
    'relevant': boolean;
    /**
     * 
     * @type {Array<MinimalPraksisavtaleDto>}
     * @memberof PraksisstedMedInfoDto
     */
    'praksisavtaler': Array<MinimalPraksisavtaleDto>;
    /**
     * 
     * @type {Array<MinimalPraksisbesvarelseDto>}
     * @memberof PraksisstedMedInfoDto
     */
    'praksisbesvarelser': Array<MinimalPraksisbesvarelseDto>;
    /**
     * 
     * @type {Array<MinimalPraksisbestillingDto>}
     * @memberof PraksisstedMedInfoDto
     */
    'praksisbestillinger': Array<MinimalPraksisbestillingDto>;
    /**
     * 
     * @type {Array<MinimalStudentPraksisplassDto>}
     * @memberof PraksisstedMedInfoDto
     */
    'studentPraksisplasser': Array<MinimalStudentPraksisplassDto>;
    /**
     * 
     * @type {Array<MinimalPraksisstedtilgangDto>}
     * @memberof PraksisstedMedInfoDto
     */
    'praksisstedtilganger': Array<MinimalPraksisstedtilgangDto>;
    /**
     * 
     * @type {Array<PraksisstedMedInfoDto>}
     * @memberof PraksisstedMedInfoDto
     */
    'undernoder': Array<PraksisstedMedInfoDto>;
}
/**
 * 
 * @export
 * @interface PraksisstedMedInfoOgHierarkiDto
 */
export interface PraksisstedMedInfoOgHierarkiDto {
    /**
     * 
     * @type {PraksisstedMedInfoDto}
     * @memberof PraksisstedMedInfoOgHierarkiDto
     */
    'selv': PraksisstedMedInfoDto;
    /**
     * 
     * @type {Array<PraksisstedMedInfoDto>}
     * @memberof PraksisstedMedInfoOgHierarkiDto
     */
    'overnoder': Array<PraksisstedMedInfoDto>;
    /**
     * 
     * @type {Array<PraksisstedMedInfoDto>}
     * @memberof PraksisstedMedInfoOgHierarkiDto
     */
    'undernoder': Array<PraksisstedMedInfoDto>;
}
/**
 * 
 * @export
 * @interface SynkroniseringsjobbDto
 */
export interface SynkroniseringsjobbDto {
    /**
     * 
     * @type {string}
     * @memberof SynkroniseringsjobbDto
     */
    'jobbtype': string;
    /**
     * 
     * @type {number}
     * @memberof SynkroniseringsjobbDto
     */
    'nesteKjoring': number;
    /**
     * 
     * @type {number}
     * @memberof SynkroniseringsjobbDto
     */
    'sisteVellykket'?: number;
    /**
     * 
     * @type {number}
     * @memberof SynkroniseringsjobbDto
     */
    'antallFeil': number;
}

        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApiInterface
        * @extends {BaseAPI}
        */
        export interface BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om synkroniseringersjobbene
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            fssyncGet(params?: { 
            options?: any
            }): Promise<Array<SynkroniseringsjobbDto>>;
            /**
            * 
                * @summary oppdater DB tabell med ny tid for synkronisering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            fssyncJobbtypePut(params: { 
                pathParams: { jobbtype: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary oppdater alle DB tabeller med ny tid for synkronisering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            fssyncPut(params?: { 
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Henter alle aktive institusjoner
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            institusjonerGet(params: { 
                queryParams?: { withoutPrevAccess?: boolean,  },
            options?: any
            }): Promise<InstitusjonerDto>;
            /**
            * 
                * @summary Henter alle praksis- og studiestedbrukere tilknyttet systembrukerens fødselsnummer
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            minebrukereGet(params?: { 
            options?: any
            }): Promise<BrukereDto>;
            /**
            * 
                * @summary Reaktiverer, deaktiverer eller resetter tilgangen til praksisstedbrukeren systembrukeren har ved praksissted med praksisstedId
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            praksisstedbrukerPraksisstedIdPut(params: { 
                pathParams: { praksisstedId: string,  },
                queryParams?: { deaktiver?: boolean, reaktiver?: boolean, resetTilgang?: boolean,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Legger til ny studiestedbruker med informasjon kopiert fra systembrukeren på studiested med studiestedId
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            studiestedbrukerStudiestedIdPost(params: { 
                pathParams: { studiestedId: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Aktiverer, deaktiverer eller resetter tilgangen til studiestedbrukeren systembrukeren har ved studiested med studiestedId
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            studiestedbrukerStudiestedIdPut(params: { 
                pathParams: { studiestedId: string,  },
                queryParams?: { deaktiver?: boolean, reaktiver?: boolean, resetTilgang?: boolean,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Legger til ny systembruker med innsendt informasjon
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            systembrukerPost(params: { 
                brukerSystemPostDto: BrukerSystemPostDto,
            options?: any
            }): Promise<void>;
            }
        /**
        * BrukerApi - object-oriented interface
        * @export
        * @class BrukerApi
        * @extends {BaseAPI}
        */
            export class BrukerApi extends BaseAPI implements BrukerApiInterface {
            /**
            * 
                * @summary hent informasjon om synkroniseringersjobbene
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async fssyncGet(params?: { 
            options?: any
            }): Promise<Array<SynkroniseringsjobbDto>> {
            return await this.GET(
        "/fssync",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary oppdater DB tabell med ny tid for synkronisering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async fssyncJobbtypePut(params: { 
                pathParams: { jobbtype: string,  },
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/fssync/{jobbtype}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary oppdater alle DB tabeller med ny tid for synkronisering
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async fssyncPut(params?: { 
            options?: any
            }): Promise<void> {
            return await this.PUT(
        "/fssync",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle aktive institusjoner
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async institusjonerGet(params: { 
                queryParams?: { withoutPrevAccess?: boolean,  },
            options?: any
            }): Promise<InstitusjonerDto> {
            return await this.GET(
        "/institusjoner",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter alle praksis- og studiestedbrukere tilknyttet systembrukerens fødselsnummer
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async minebrukereGet(params?: { 
            options?: any
            }): Promise<BrukereDto> {
            return await this.GET(
        "/minebrukere",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Reaktiverer, deaktiverer eller resetter tilgangen til praksisstedbrukeren systembrukeren har ved praksissted med praksisstedId
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async praksisstedbrukerPraksisstedIdPut(params: { 
                pathParams: { praksisstedId: string,  },
                queryParams?: { deaktiver?: boolean, reaktiver?: boolean, resetTilgang?: boolean,  },
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/praksisstedbruker/{praksisstedId}", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legger til ny studiestedbruker med informasjon kopiert fra systembrukeren på studiested med studiestedId
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async studiestedbrukerStudiestedIdPost(params: { 
                pathParams: { studiestedId: string,  },
            options?: any
            }): Promise<void> {
            return await this.POST(
        this.path("/studiestedbruker/{studiestedId}", params.pathParams),
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Aktiverer, deaktiverer eller resetter tilgangen til studiestedbrukeren systembrukeren har ved studiested med studiestedId
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async studiestedbrukerStudiestedIdPut(params: { 
                pathParams: { studiestedId: string,  },
                queryParams?: { deaktiver?: boolean, reaktiver?: boolean, resetTilgang?: boolean,  },
            options?: any
            }): Promise<void> {
            return await this.PUT(
        this.path("/studiestedbruker/{studiestedId}", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Legger til ny systembruker med innsendt informasjon
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof BrukerApi
            */
            public async systembrukerPost(params: { 
            brukerSystemPostDto: BrukerSystemPostDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        "/systembruker",
        {},
        { body: params.brukerSystemPostDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockBrukerApi(operations: {
            fssyncGet?: (params?: { 
                options?: any
                }) => Promise<Array<SynkroniseringsjobbDto>>
            fssyncJobbtypePut?: (params: { 
                    pathParams: { jobbtype: string,  },
                options?: any
                }) => Promise<void>
            fssyncPut?: (params?: { 
                options?: any
                }) => Promise<void>
            institusjonerGet?: (params: { 
                    queryParams?: { withoutPrevAccess?: boolean,  },
                options?: any
                }) => Promise<InstitusjonerDto>
            minebrukereGet?: (params?: { 
                options?: any
                }) => Promise<BrukereDto>
            praksisstedbrukerPraksisstedIdPut?: (params: { 
                    pathParams: { praksisstedId: string,  },
                    queryParams?: { deaktiver?: boolean, reaktiver?: boolean, resetTilgang?: boolean,  },
                options?: any
                }) => Promise<void>
            studiestedbrukerStudiestedIdPost?: (params: { 
                    pathParams: { studiestedId: string,  },
                options?: any
                }) => Promise<void>
            studiestedbrukerStudiestedIdPut?: (params: { 
                    pathParams: { studiestedId: string,  },
                    queryParams?: { deaktiver?: boolean, reaktiver?: boolean, resetTilgang?: boolean,  },
                options?: any
                }) => Promise<void>
            systembrukerPost?: (params: { 
                brukerSystemPostDto: BrukerSystemPostDto,
                options?: any
                }) => Promise<void>
            }): BrukerApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            fssyncGet: (operations.fssyncGet || reject("fssyncGet")),
            fssyncJobbtypePut: (operations.fssyncJobbtypePut || reject("fssyncJobbtypePut")),
            fssyncPut: (operations.fssyncPut || reject("fssyncPut")),
            institusjonerGet: (operations.institusjonerGet || reject("institusjonerGet")),
            minebrukereGet: (operations.minebrukereGet || reject("minebrukereGet")),
            praksisstedbrukerPraksisstedIdPut: (operations.praksisstedbrukerPraksisstedIdPut || reject("praksisstedbrukerPraksisstedIdPut")),
            studiestedbrukerStudiestedIdPost: (operations.studiestedbrukerStudiestedIdPost || reject("studiestedbrukerStudiestedIdPost")),
            studiestedbrukerStudiestedIdPut: (operations.studiestedbrukerStudiestedIdPut || reject("studiestedbrukerStudiestedIdPut")),
            systembrukerPost: (operations.systembrukerPost || reject("systembrukerPost")),
            };
            }


        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApiInterface
        * @extends {BaseAPI}
        */
        export interface PraksisstedApiInterface {
            /**
            * 
                * @summary Henter alle praksissteder som matcher fulltekst søket
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstederFulltekstGet(params: { 
                queryParams?: { fulltekst: string, limit?: number, includeDeleted?: boolean,  },
            options?: any
            }): Promise<Array<MinimalPraksisstedDto>>;
            /**
            * 
                * @summary Henter tre med praksisstedinfo
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            praksisstedstreIdGet(params: { 
                pathParams: { id: string,  },
                queryParams?: { includeDeleted?: boolean,  },
            options?: any
            }): Promise<PraksisstedMedInfoOgHierarkiDto>;
            }
        /**
        * PraksisstedApi - object-oriented interface
        * @export
        * @class PraksisstedApi
        * @extends {BaseAPI}
        */
            export class PraksisstedApi extends BaseAPI implements PraksisstedApiInterface {
            /**
            * 
                * @summary Henter alle praksissteder som matcher fulltekst søket
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstederFulltekstGet(params: { 
                queryParams?: { fulltekst: string, limit?: number, includeDeleted?: boolean,  },
            options?: any
            }): Promise<Array<MinimalPraksisstedDto>> {
            return await this.GET(
        "/praksissteder/fulltekst",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Henter tre med praksisstedinfo
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof PraksisstedApi
            */
            public async praksisstedstreIdGet(params: { 
                pathParams: { id: string,  },
                queryParams?: { includeDeleted?: boolean,  },
            options?: any
            }): Promise<PraksisstedMedInfoOgHierarkiDto> {
            return await this.GET(
        this.path("/praksisstedstre/{id}", params.pathParams),
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
        }
            export function mockPraksisstedApi(operations: {
            praksisstederFulltekstGet?: (params: { 
                    queryParams?: { fulltekst: string, limit?: number, includeDeleted?: boolean,  },
                options?: any
                }) => Promise<Array<MinimalPraksisstedDto>>
            praksisstedstreIdGet?: (params: { 
                    pathParams: { id: string,  },
                    queryParams?: { includeDeleted?: boolean,  },
                options?: any
                }) => Promise<PraksisstedMedInfoOgHierarkiDto>
            }): PraksisstedApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            praksisstederFulltekstGet: (operations.praksisstederFulltekstGet || reject("praksisstederFulltekstGet")),
            praksisstedstreIdGet: (operations.praksisstedstreIdGet || reject("praksisstedstreIdGet")),
            };
            }



export class Random {
    seed: number;
    constructor(seed: number) {
        this.seed = seed % 2147483647;
        if (this.seed <= 0) this.seed += 2147483646;
    }
    next(): number {
        this.seed = this.seed * 16807 % 2147483647;
        return this.seed;
    }
    nextFloat(): number {
        return (this.next() - 1) / 2147483646;
    }
    nextInt(limit: number): number {
        return this.next() % limit;
    }
    pickOne<T>(options: Array<T>): T {
        return options[this.nextInt(options.length)];
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = this.nextInt(16) | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    nextBoolean() {
        return this.nextInt(2) == 0;
    }
}

type Factory<T> = {
    [P in keyof T]?: ((sampleData: TestSampleData) => T[P])|T[P];
};
type EnumFactory<T> = ((sampleData: TestSampleData) => T)|T;
export interface SampleModelFactories {
    BrukerPraksisstedDto?: Factory<BrukerPraksisstedDto> | ((testData: TestSampleData) => BrukerPraksisstedDto);
    BrukerPraksisstedtilgangDto?: Factory<BrukerPraksisstedtilgangDto> | ((testData: TestSampleData) => BrukerPraksisstedtilgangDto);
    BrukerStudiestedDto?: Factory<BrukerStudiestedDto> | ((testData: TestSampleData) => BrukerStudiestedDto);
    BrukerStudiestedtilgangDto?: Factory<BrukerStudiestedtilgangDto> | ((testData: TestSampleData) => BrukerStudiestedtilgangDto);
    BrukerSystemPostDto?: Factory<BrukerSystemPostDto> | ((testData: TestSampleData) => BrukerSystemPostDto);
    BrukereDto?: Factory<BrukereDto> | ((testData: TestSampleData) => BrukereDto);
    BrukerrollePraksisstedDto?: Factory<BrukerrollePraksisstedDto> | ((testData: TestSampleData) => BrukerrollePraksisstedDto);
    BrukerrolleStudiestedDto?: Factory<BrukerrolleStudiestedDto> | ((testData: TestSampleData) => BrukerrolleStudiestedDto);
    InstitusjonerDto?: Factory<InstitusjonerDto> | ((testData: TestSampleData) => InstitusjonerDto);
    MinimalPraksisavtaleDto?: Factory<MinimalPraksisavtaleDto> | ((testData: TestSampleData) => MinimalPraksisavtaleDto);
    MinimalPraksisbestillingDto?: Factory<MinimalPraksisbestillingDto> | ((testData: TestSampleData) => MinimalPraksisbestillingDto);
    MinimalPraksisbesvarelseDto?: Factory<MinimalPraksisbesvarelseDto> | ((testData: TestSampleData) => MinimalPraksisbesvarelseDto);
    MinimalPraksisstedDto?: Factory<MinimalPraksisstedDto> | ((testData: TestSampleData) => MinimalPraksisstedDto);
    MinimalPraksisstedtilgangDto?: Factory<MinimalPraksisstedtilgangDto> | ((testData: TestSampleData) => MinimalPraksisstedtilgangDto);
    MinimalStudentPraksisplassDto?: Factory<MinimalStudentPraksisplassDto> | ((testData: TestSampleData) => MinimalStudentPraksisplassDto);
    MinimalStudiestedDto?: Factory<MinimalStudiestedDto> | ((testData: TestSampleData) => MinimalStudiestedDto);
    PraksisavtaleStedBestillingspunktTypeDto?: Factory<PraksisavtaleStedBestillingspunktTypeDto> | ((testData: TestSampleData) => PraksisavtaleStedBestillingspunktTypeDto);
    PraksisstedMedInfoDto?: Factory<PraksisstedMedInfoDto> | ((testData: TestSampleData) => PraksisstedMedInfoDto);
    PraksisstedMedInfoOgHierarkiDto?: Factory<PraksisstedMedInfoOgHierarkiDto> | ((testData: TestSampleData) => PraksisstedMedInfoOgHierarkiDto);
    SynkroniseringsjobbDto?: Factory<SynkroniseringsjobbDto> | ((testData: TestSampleData) => SynkroniseringsjobbDto);
}
export interface SamplePropertyValues {
    [key: string]: (sampleData: TestSampleData) => any;
}

export interface RandomGenerator {
    nextFloat: () => number;
    nextInt: (limit: number) => number;
    nextBoolean: () => boolean;
    pickOne: <T>(options: Array<T>) => T;
    uuidv4: ()  => string;
    randomEmail: () => string;
    randomPastDateTime: (now: Date) => Date;
    generate: (modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean) => any;
}

export interface TestData {
    seed?: number;
    sampleModelProperties?: SampleModelFactories;
    samplePropertyValues?: SamplePropertyValues;
}
export class TestSampleData implements RandomGenerator {
    random: Random;
    sampleModelProperties: any;
    samplePropertyValues: SamplePropertyValues;
    constructor(testData: TestData) {
        this.random = new Random(testData.seed || 100);
        this.sampleModelProperties = testData.sampleModelProperties || {};
        this.samplePropertyValues = testData.samplePropertyValues || {};
    }
    nextFloat() { return this.random.nextFloat(); }
    nextInt(limit: number) { return this.random.nextInt(limit); }
    nextBoolean() { return this.random.nextBoolean(); }
    pickOne<T>(options: Array<T>) { return this.random.pickOne(options); }
    uuidv4() { return this.random.uuidv4(); }
    randomEmail() {
        return this.pickOne(["james", "mary", "john", "patricia", "robert", "jennifer", "michael", "linda"]) +
            "." + this.pickOne(["smith", "williams", "johnson", "jones", "brown", "davis", "miller", "wilson"]) +
            "@" + this.pickOne(["a", "b", "c", "d", "e"]) + ".example." + this.pickOne(["net", "com", "org"]);
    }
    randomPastDateTime(now: Date) {
        return new Date((now.getTime() - this.nextInt(4*7*24*60*60*1000)));
    }
    generate(modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean): any {
        if (this.sampleModelProperties[modelClass]) {
            const propertyFactory: Factory<any> = this.sampleModelProperties[modelClass][modelVar];
            if (propertyFactory && typeof propertyFactory === "function") {
                return propertyFactory(this);
            } else if (propertyFactory) {
                return propertyFactory;
            }
        }
        if (this.samplePropertyValues[modelVar]) {
            return this.samplePropertyValues[modelVar](this);
        }
        if (example && example !== "null") return example;
        if (dataType === "Array<string>") {
            return Array.from({length: this.arrayLength("Array<string>")}).map((i) => "foo " + i);
        }
        if (dataType.startsWith("Array<")) {
            return this.sample(dataType);
        }
        if (modelVar.endsWith("Id") || modelVar === "id") {
            return this.uuidv4();
        }
        if (dataType === "boolean") {
            return this.nextBoolean();
        }
        if (dataType === "number") {
            return this.nextInt(100);
        }
        const key = `sample${dataType}` as keyof TestSampleData;
        if( typeof this[key] === "function"){
            return this[key]();
        }
        return "foo";
    }
    arrayLength(modelClass: string) {
        return this.nextInt(3) + 1;
    }
    sample(modelName: string): any {
        switch(modelName) {
            case "BrukerPraksisstedDto": return this.sampleBrukerPraksisstedDto({});
            case "Array<BrukerPraksisstedDto>": return this.sampleArrayBrukerPraksisstedDto({});
            case "BrukerPraksisstedtilgangDto": return this.sampleBrukerPraksisstedtilgangDto({});
            case "Array<BrukerPraksisstedtilgangDto>": return this.sampleArrayBrukerPraksisstedtilgangDto({});
            case "BrukerStudiestedDto": return this.sampleBrukerStudiestedDto({});
            case "Array<BrukerStudiestedDto>": return this.sampleArrayBrukerStudiestedDto({});
            case "BrukerStudiestedtilgangDto": return this.sampleBrukerStudiestedtilgangDto({});
            case "Array<BrukerStudiestedtilgangDto>": return this.sampleArrayBrukerStudiestedtilgangDto({});
            case "BrukerSystemPostDto": return this.sampleBrukerSystemPostDto({});
            case "Array<BrukerSystemPostDto>": return this.sampleArrayBrukerSystemPostDto({});
            case "BrukereDto": return this.sampleBrukereDto({});
            case "Array<BrukereDto>": return this.sampleArrayBrukereDto({});
            case "BrukerrollePraksisstedDto": return this.sampleBrukerrollePraksisstedDto();
            case "Array<BrukerrollePraksisstedDto>": return this.sampleArrayBrukerrollePraksisstedDto();
            case "BrukerrolleStudiestedDto": return this.sampleBrukerrolleStudiestedDto();
            case "Array<BrukerrolleStudiestedDto>": return this.sampleArrayBrukerrolleStudiestedDto();
            case "InstitusjonerDto": return this.sampleInstitusjonerDto({});
            case "Array<InstitusjonerDto>": return this.sampleArrayInstitusjonerDto({});
            case "MinimalPraksisavtaleDto": return this.sampleMinimalPraksisavtaleDto({});
            case "Array<MinimalPraksisavtaleDto>": return this.sampleArrayMinimalPraksisavtaleDto({});
            case "MinimalPraksisbestillingDto": return this.sampleMinimalPraksisbestillingDto({});
            case "Array<MinimalPraksisbestillingDto>": return this.sampleArrayMinimalPraksisbestillingDto({});
            case "MinimalPraksisbesvarelseDto": return this.sampleMinimalPraksisbesvarelseDto({});
            case "Array<MinimalPraksisbesvarelseDto>": return this.sampleArrayMinimalPraksisbesvarelseDto({});
            case "MinimalPraksisstedDto": return this.sampleMinimalPraksisstedDto({});
            case "Array<MinimalPraksisstedDto>": return this.sampleArrayMinimalPraksisstedDto({});
            case "MinimalPraksisstedtilgangDto": return this.sampleMinimalPraksisstedtilgangDto({});
            case "Array<MinimalPraksisstedtilgangDto>": return this.sampleArrayMinimalPraksisstedtilgangDto({});
            case "MinimalStudentPraksisplassDto": return this.sampleMinimalStudentPraksisplassDto({});
            case "Array<MinimalStudentPraksisplassDto>": return this.sampleArrayMinimalStudentPraksisplassDto({});
            case "MinimalStudiestedDto": return this.sampleMinimalStudiestedDto({});
            case "Array<MinimalStudiestedDto>": return this.sampleArrayMinimalStudiestedDto({});
            case "PraksisavtaleStedBestillingspunktTypeDto": return this.samplePraksisavtaleStedBestillingspunktTypeDto();
            case "Array<PraksisavtaleStedBestillingspunktTypeDto>": return this.sampleArrayPraksisavtaleStedBestillingspunktTypeDto();
            case "PraksisstedMedInfoDto": return this.samplePraksisstedMedInfoDto({});
            case "Array<PraksisstedMedInfoDto>": return this.sampleArrayPraksisstedMedInfoDto({});
            case "PraksisstedMedInfoOgHierarkiDto": return this.samplePraksisstedMedInfoOgHierarkiDto({});
            case "Array<PraksisstedMedInfoOgHierarkiDto>": return this.sampleArrayPraksisstedMedInfoOgHierarkiDto({});
            case "SynkroniseringsjobbDto": return this.sampleSynkroniseringsjobbDto({});
            case "Array<SynkroniseringsjobbDto>": return this.sampleArraySynkroniseringsjobbDto({});
            default: throw new Error("Unknown type "+ modelName);
        }
    }
    sampleBrukerPraksisstedDto(template?: Factory<BrukerPraksisstedDto>): BrukerPraksisstedDto {
        if (typeof this.sampleModelProperties["BrukerPraksisstedDto"] === "function") {
            return this.sampleModelProperties["BrukerPraksisstedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("BrukerPraksisstedDto", "id", "string", "47593db1-be0a-4c94-996e-cc3af946dcfc", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("BrukerPraksisstedDto", "fornavn", "string", "null", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("BrukerPraksisstedDto", "etternavn", "string", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("BrukerPraksisstedDto", "epost", "string", "null", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("BrukerPraksisstedDto", "tilganger", "Array<BrukerPraksisstedtilgangDto>", "null", false),
            administratorToppnivaa: template && template.administratorToppnivaa ? (typeof template.administratorToppnivaa === "function" ? (template.administratorToppnivaa as Function)(this) : template.administratorToppnivaa): this.generate("BrukerPraksisstedDto", "administratorToppnivaa", "boolean", "null", false),
            deaktivert: template && template.deaktivert ? (typeof template.deaktivert === "function" ? (template.deaktivert as Function)(this) : template.deaktivert): this.generate("BrukerPraksisstedDto", "deaktivert", "boolean", "null", false),
        };
    }
    sampleArrayBrukerPraksisstedDto(template?: Factory<BrukerPraksisstedDto>, length?: number): Array<BrukerPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("BrukerPraksisstedDto")}).map(() => this.sampleBrukerPraksisstedDto(template));
    }
    sampleBrukerPraksisstedtilgangDto(template?: Factory<BrukerPraksisstedtilgangDto>): BrukerPraksisstedtilgangDto {
        if (typeof this.sampleModelProperties["BrukerPraksisstedtilgangDto"] === "function") {
            return this.sampleModelProperties["BrukerPraksisstedtilgangDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("BrukerPraksisstedtilgangDto", "id", "string", "null", false),
            navnToppnode: template && template.navnToppnode ? (typeof template.navnToppnode === "function" ? (template.navnToppnode as Function)(this) : template.navnToppnode): this.generate("BrukerPraksisstedtilgangDto", "navnToppnode", "string", "null", false),
            navnPraksissted: template && template.navnPraksissted ? (typeof template.navnPraksissted === "function" ? (template.navnPraksissted as Function)(this) : template.navnPraksissted): this.generate("BrukerPraksisstedtilgangDto", "navnPraksissted", "string", "null", false),
            rolle: template && template.rolle ? (typeof template.rolle === "function" ? (template.rolle as Function)(this) : template.rolle): this.generate("BrukerPraksisstedtilgangDto", "rolle", "BrukerrollePraksisstedDto", "null", false),
        };
    }
    sampleArrayBrukerPraksisstedtilgangDto(template?: Factory<BrukerPraksisstedtilgangDto>, length?: number): Array<BrukerPraksisstedtilgangDto> {
        return Array.from({length: length || this.arrayLength("BrukerPraksisstedtilgangDto")}).map(() => this.sampleBrukerPraksisstedtilgangDto(template));
    }
    sampleBrukerStudiestedDto(template?: Factory<BrukerStudiestedDto>): BrukerStudiestedDto {
        if (typeof this.sampleModelProperties["BrukerStudiestedDto"] === "function") {
            return this.sampleModelProperties["BrukerStudiestedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("BrukerStudiestedDto", "id", "string", "47593db1-be0a-4c94-996e-cc3af946dcfc", false),
            feideId: template && template.feideId ? (typeof template.feideId === "function" ? (template.feideId as Function)(this) : template.feideId): this.generate("BrukerStudiestedDto", "feideId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("BrukerStudiestedDto", "fornavn", "string", "null", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("BrukerStudiestedDto", "etternavn", "string", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("BrukerStudiestedDto", "epost", "string", "null", false),
            tilganger: template && template.tilganger ? (typeof template.tilganger === "function" ? (template.tilganger as Function)(this) : template.tilganger): this.generate("BrukerStudiestedDto", "tilganger", "Array<BrukerStudiestedtilgangDto>", "null", false),
            administratorToppnivaa: template && template.administratorToppnivaa ? (typeof template.administratorToppnivaa === "function" ? (template.administratorToppnivaa as Function)(this) : template.administratorToppnivaa): this.generate("BrukerStudiestedDto", "administratorToppnivaa", "boolean", "null", false),
            deaktivert: template && template.deaktivert ? (typeof template.deaktivert === "function" ? (template.deaktivert as Function)(this) : template.deaktivert): this.generate("BrukerStudiestedDto", "deaktivert", "boolean", "null", false),
        };
    }
    sampleArrayBrukerStudiestedDto(template?: Factory<BrukerStudiestedDto>, length?: number): Array<BrukerStudiestedDto> {
        return Array.from({length: length || this.arrayLength("BrukerStudiestedDto")}).map(() => this.sampleBrukerStudiestedDto(template));
    }
    sampleBrukerStudiestedtilgangDto(template?: Factory<BrukerStudiestedtilgangDto>): BrukerStudiestedtilgangDto {
        if (typeof this.sampleModelProperties["BrukerStudiestedtilgangDto"] === "function") {
            return this.sampleModelProperties["BrukerStudiestedtilgangDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("BrukerStudiestedtilgangDto", "id", "string", "null", false),
            navnToppnode: template && template.navnToppnode ? (typeof template.navnToppnode === "function" ? (template.navnToppnode as Function)(this) : template.navnToppnode): this.generate("BrukerStudiestedtilgangDto", "navnToppnode", "string", "null", false),
            navnStudiested: template && template.navnStudiested ? (typeof template.navnStudiested === "function" ? (template.navnStudiested as Function)(this) : template.navnStudiested): this.generate("BrukerStudiestedtilgangDto", "navnStudiested", "string", "null", false),
            rolle: template && template.rolle ? (typeof template.rolle === "function" ? (template.rolle as Function)(this) : template.rolle): this.generate("BrukerStudiestedtilgangDto", "rolle", "BrukerrolleStudiestedDto", "null", false),
        };
    }
    sampleArrayBrukerStudiestedtilgangDto(template?: Factory<BrukerStudiestedtilgangDto>, length?: number): Array<BrukerStudiestedtilgangDto> {
        return Array.from({length: length || this.arrayLength("BrukerStudiestedtilgangDto")}).map(() => this.sampleBrukerStudiestedtilgangDto(template));
    }
    sampleBrukerSystemPostDto(template?: Factory<BrukerSystemPostDto>): BrukerSystemPostDto {
        if (typeof this.sampleModelProperties["BrukerSystemPostDto"] === "function") {
            return this.sampleModelProperties["BrukerSystemPostDto"](this);
        }

        return {
            foedselsnummer: template && template.foedselsnummer ? (typeof template.foedselsnummer === "function" ? (template.foedselsnummer as Function)(this) : template.foedselsnummer): this.generate("BrukerSystemPostDto", "foedselsnummer", "string", "null", false),
            feideId: template && template.feideId ? (typeof template.feideId === "function" ? (template.feideId as Function)(this) : template.feideId): this.generate("BrukerSystemPostDto", "feideId", "string", "null", false),
            fornavn: template && template.fornavn ? (typeof template.fornavn === "function" ? (template.fornavn as Function)(this) : template.fornavn): this.generate("BrukerSystemPostDto", "fornavn", "string", "null", false),
            etternavn: template && template.etternavn ? (typeof template.etternavn === "function" ? (template.etternavn as Function)(this) : template.etternavn): this.generate("BrukerSystemPostDto", "etternavn", "string", "null", false),
            epost: template && template.epost ? (typeof template.epost === "function" ? (template.epost as Function)(this) : template.epost): this.generate("BrukerSystemPostDto", "epost", "string", "null", false),
        };
    }
    sampleArrayBrukerSystemPostDto(template?: Factory<BrukerSystemPostDto>, length?: number): Array<BrukerSystemPostDto> {
        return Array.from({length: length || this.arrayLength("BrukerSystemPostDto")}).map(() => this.sampleBrukerSystemPostDto(template));
    }
    sampleBrukereDto(template?: Factory<BrukereDto>): BrukereDto {
        if (typeof this.sampleModelProperties["BrukereDto"] === "function") {
            return this.sampleModelProperties["BrukereDto"](this);
        }

        return {
            studiestedbrukere: template && template.studiestedbrukere ? (typeof template.studiestedbrukere === "function" ? (template.studiestedbrukere as Function)(this) : template.studiestedbrukere): this.generate("BrukereDto", "studiestedbrukere", "Array<BrukerStudiestedDto>", "null", false),
            praksisstedbrukere: template && template.praksisstedbrukere ? (typeof template.praksisstedbrukere === "function" ? (template.praksisstedbrukere as Function)(this) : template.praksisstedbrukere): this.generate("BrukereDto", "praksisstedbrukere", "Array<BrukerPraksisstedDto>", "null", false),
        };
    }
    sampleArrayBrukereDto(template?: Factory<BrukereDto>, length?: number): Array<BrukereDto> {
        return Array.from({length: length || this.arrayLength("BrukereDto")}).map(() => this.sampleBrukereDto(template));
    }
    sampleBrukerrollePraksisstedDto(template?: EnumFactory<BrukerrollePraksisstedDto>): BrukerrollePraksisstedDto {
        if (typeof this.sampleModelProperties["BrukerrollePraksisstedDto"] === "function") {
            return this.sampleModelProperties["BrukerrollePraksisstedDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                BrukerrollePraksisstedDto.Administrator,
                BrukerrollePraksisstedDto.Skriverettighet,
                BrukerrollePraksisstedDto.Leserettighet
        ]);
    }
    sampleArrayBrukerrollePraksisstedDto(template?: EnumFactory<BrukerrollePraksisstedDto>, length?: number): Array<BrukerrollePraksisstedDto> {
        return Array.from({length: length || this.arrayLength("BrukerrollePraksisstedDto")}).map(() => this.sampleBrukerrollePraksisstedDto());
    }
    sampleBrukerrolleStudiestedDto(template?: EnumFactory<BrukerrolleStudiestedDto>): BrukerrolleStudiestedDto {
        if (typeof this.sampleModelProperties["BrukerrolleStudiestedDto"] === "function") {
            return this.sampleModelProperties["BrukerrolleStudiestedDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                BrukerrolleStudiestedDto.Administrator,
                BrukerrolleStudiestedDto.Registrererettighet,
                BrukerrolleStudiestedDto.Skriverettighet,
                BrukerrolleStudiestedDto.Leserettighet
        ]);
    }
    sampleArrayBrukerrolleStudiestedDto(template?: EnumFactory<BrukerrolleStudiestedDto>, length?: number): Array<BrukerrolleStudiestedDto> {
        return Array.from({length: length || this.arrayLength("BrukerrolleStudiestedDto")}).map(() => this.sampleBrukerrolleStudiestedDto());
    }
    sampleInstitusjonerDto(template?: Factory<InstitusjonerDto>): InstitusjonerDto {
        if (typeof this.sampleModelProperties["InstitusjonerDto"] === "function") {
            return this.sampleModelProperties["InstitusjonerDto"](this);
        }

        return {
            institusjoner: template && template.institusjoner ? (typeof template.institusjoner === "function" ? (template.institusjoner as Function)(this) : template.institusjoner): this.generate("InstitusjonerDto", "institusjoner", "Array<MinimalStudiestedDto>", "null", false),
        };
    }
    sampleArrayInstitusjonerDto(template?: Factory<InstitusjonerDto>, length?: number): Array<InstitusjonerDto> {
        return Array.from({length: length || this.arrayLength("InstitusjonerDto")}).map(() => this.sampleInstitusjonerDto(template));
    }
    sampleMinimalPraksisavtaleDto(template?: Factory<MinimalPraksisavtaleDto>): MinimalPraksisavtaleDto {
        if (typeof this.sampleModelProperties["MinimalPraksisavtaleDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisavtaleDto"](this);
        }

        return {
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("MinimalPraksisavtaleDto", "avtaleId", "string", "47593db1-be0a-4c94-996e-cc3af946dcfc", false),
            praksisavtaleNavn: template && template.praksisavtaleNavn ? (typeof template.praksisavtaleNavn === "function" ? (template.praksisavtaleNavn as Function)(this) : template.praksisavtaleNavn): this.generate("MinimalPraksisavtaleDto", "praksisavtaleNavn", "string", "null", false),
            avtalestart: template && template.avtalestart ? (typeof template.avtalestart === "function" ? (template.avtalestart as Function)(this) : template.avtalestart): this.generate("MinimalPraksisavtaleDto", "avtalestart", "string", "Thu Aug 01 00:00:00 UTC 2019", false),
            avtaleslutt: template && template.avtaleslutt ? (typeof template.avtaleslutt === "function" ? (template.avtaleslutt as Function)(this) : template.avtaleslutt): this.generate("MinimalPraksisavtaleDto", "avtaleslutt", "string", "Tue Dec 31 00:00:00 UTC 2019", false),
            statusAktiv: template && template.statusAktiv ? (typeof template.statusAktiv === "function" ? (template.statusAktiv as Function)(this) : template.statusAktiv): this.generate("MinimalPraksisavtaleDto", "statusAktiv", "string", "null", false),
        };
    }
    sampleArrayMinimalPraksisavtaleDto(template?: Factory<MinimalPraksisavtaleDto>, length?: number): Array<MinimalPraksisavtaleDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisavtaleDto")}).map(() => this.sampleMinimalPraksisavtaleDto(template));
    }
    sampleMinimalPraksisbestillingDto(template?: Factory<MinimalPraksisbestillingDto>): MinimalPraksisbestillingDto {
        if (typeof this.sampleModelProperties["MinimalPraksisbestillingDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisbestillingDto"](this);
        }

        return {
            bestillingId: template && template.bestillingId ? (typeof template.bestillingId === "function" ? (template.bestillingId as Function)(this) : template.bestillingId): this.generate("MinimalPraksisbestillingDto", "bestillingId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            delt: template && template.delt ? (typeof template.delt === "function" ? (template.delt as Function)(this) : template.delt): this.generate("MinimalPraksisbestillingDto", "delt", "boolean", "false", false),
            avtaleId: template && template.avtaleId ? (typeof template.avtaleId === "function" ? (template.avtaleId as Function)(this) : template.avtaleId): this.generate("MinimalPraksisbestillingDto", "avtaleId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("MinimalPraksisbestillingDto", "praksisstedId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            aktivitetId: template && template.aktivitetId ? (typeof template.aktivitetId === "function" ? (template.aktivitetId as Function)(this) : template.aktivitetId): this.generate("MinimalPraksisbestillingDto", "aktivitetId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            bestilling: template && template.bestilling ? (typeof template.bestilling === "function" ? (template.bestilling as Function)(this) : template.bestilling): this.generate("MinimalPraksisbestillingDto", "bestilling", "number", "20", false),
            bestillingsmodus: template && template.bestillingsmodus ? (typeof template.bestillingsmodus === "function" ? (template.bestillingsmodus as Function)(this) : template.bestillingsmodus): this.generate("MinimalPraksisbestillingDto", "bestillingsmodus", "PraksisavtaleStedBestillingspunktTypeDto", "null", false),
        };
    }
    sampleArrayMinimalPraksisbestillingDto(template?: Factory<MinimalPraksisbestillingDto>, length?: number): Array<MinimalPraksisbestillingDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisbestillingDto")}).map(() => this.sampleMinimalPraksisbestillingDto(template));
    }
    sampleMinimalPraksisbesvarelseDto(template?: Factory<MinimalPraksisbesvarelseDto>): MinimalPraksisbesvarelseDto {
        if (typeof this.sampleModelProperties["MinimalPraksisbesvarelseDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisbesvarelseDto"](this);
        }

        return {
            besvarelseId: template && template.besvarelseId ? (typeof template.besvarelseId === "function" ? (template.besvarelseId as Function)(this) : template.besvarelseId): this.generate("MinimalPraksisbesvarelseDto", "besvarelseId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            bestillingId: template && template.bestillingId ? (typeof template.bestillingId === "function" ? (template.bestillingId as Function)(this) : template.bestillingId): this.generate("MinimalPraksisbesvarelseDto", "bestillingId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("MinimalPraksisbesvarelseDto", "praksisstedId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            kapasitet: template && template.kapasitet ? (typeof template.kapasitet === "function" ? (template.kapasitet as Function)(this) : template.kapasitet): this.generate("MinimalPraksisbesvarelseDto", "kapasitet", "number", "10", false),
        };
    }
    sampleArrayMinimalPraksisbesvarelseDto(template?: Factory<MinimalPraksisbesvarelseDto>, length?: number): Array<MinimalPraksisbesvarelseDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisbesvarelseDto")}).map(() => this.sampleMinimalPraksisbesvarelseDto(template));
    }
    sampleMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>): MinimalPraksisstedDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("MinimalPraksisstedDto", "id", "string", "0aaedfff-d134-447a-b8fc-39688210c29a", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalPraksisstedDto", "navn", "string", "Lovisenberg Diakonale Sykehus", false),
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("MinimalPraksisstedDto", "kode", "string", "882", false),
        };
    }
    sampleArrayMinimalPraksisstedDto(template?: Factory<MinimalPraksisstedDto>, length?: number): Array<MinimalPraksisstedDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedDto")}).map(() => this.sampleMinimalPraksisstedDto(template));
    }
    sampleMinimalPraksisstedtilgangDto(template?: Factory<MinimalPraksisstedtilgangDto>): MinimalPraksisstedtilgangDto {
        if (typeof this.sampleModelProperties["MinimalPraksisstedtilgangDto"] === "function") {
            return this.sampleModelProperties["MinimalPraksisstedtilgangDto"](this);
        }

        return {
            brukerId: template && template.brukerId ? (typeof template.brukerId === "function" ? (template.brukerId as Function)(this) : template.brukerId): this.generate("MinimalPraksisstedtilgangDto", "brukerId", "string", "7d0ca962-5356-11ec-888b-c7816e3a0df2", false),
            praksisstedId: template && template.praksisstedId ? (typeof template.praksisstedId === "function" ? (template.praksisstedId as Function)(this) : template.praksisstedId): this.generate("MinimalPraksisstedtilgangDto", "praksisstedId", "string", "7d0ca962-5356-11ec-888b-c7816e3a0df2", false),
            tilgangstype: template && template.tilgangstype ? (typeof template.tilgangstype === "function" ? (template.tilgangstype as Function)(this) : template.tilgangstype): this.pickOne([MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum.Admin,MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum.Skriv,MinimalPraksisstedtilgangDtoTilgangstypeDtoEnum.Les]),
        };
    }
    sampleArrayMinimalPraksisstedtilgangDto(template?: Factory<MinimalPraksisstedtilgangDto>, length?: number): Array<MinimalPraksisstedtilgangDto> {
        return Array.from({length: length || this.arrayLength("MinimalPraksisstedtilgangDto")}).map(() => this.sampleMinimalPraksisstedtilgangDto(template));
    }
    sampleMinimalStudentPraksisplassDto(template?: Factory<MinimalStudentPraksisplassDto>): MinimalStudentPraksisplassDto {
        if (typeof this.sampleModelProperties["MinimalStudentPraksisplassDto"] === "function") {
            return this.sampleModelProperties["MinimalStudentPraksisplassDto"](this);
        }

        return {
            studentPraksisplassId: template && template.studentPraksisplassId ? (typeof template.studentPraksisplassId === "function" ? (template.studentPraksisplassId as Function)(this) : template.studentPraksisplassId): this.generate("MinimalStudentPraksisplassDto", "studentPraksisplassId", "string", "1aaedfff-d134-447a-b8fc-39688210c29a", false),
            praksisbesvarelseId: template && template.praksisbesvarelseId ? (typeof template.praksisbesvarelseId === "function" ? (template.praksisbesvarelseId as Function)(this) : template.praksisbesvarelseId): this.generate("MinimalStudentPraksisplassDto", "praksisbesvarelseId", "string", "7d0ca962-5356-11ec-888b-c7816e3a0df2", false),
            studentPraksisklasseId: template && template.studentPraksisklasseId ? (typeof template.studentPraksisklasseId === "function" ? (template.studentPraksisklasseId as Function)(this) : template.studentPraksisklasseId): this.generate("MinimalStudentPraksisplassDto", "studentPraksisklasseId", "string", "94eb301c-5356-11ec-bf3c-43ee713ff41b", false),
            aktivitetId: template && template.aktivitetId ? (typeof template.aktivitetId === "function" ? (template.aktivitetId as Function)(this) : template.aktivitetId): this.generate("MinimalStudentPraksisplassDto", "aktivitetId", "string", "a225f0aa-5356-11ec-8477-4739f9bbf16e", false),
        };
    }
    sampleArrayMinimalStudentPraksisplassDto(template?: Factory<MinimalStudentPraksisplassDto>, length?: number): Array<MinimalStudentPraksisplassDto> {
        return Array.from({length: length || this.arrayLength("MinimalStudentPraksisplassDto")}).map(() => this.sampleMinimalStudentPraksisplassDto(template));
    }
    sampleMinimalStudiestedDto(template?: Factory<MinimalStudiestedDto>): MinimalStudiestedDto {
        if (typeof this.sampleModelProperties["MinimalStudiestedDto"] === "function") {
            return this.sampleModelProperties["MinimalStudiestedDto"](this);
        }

        return {
            studiestedId: template && template.studiestedId ? (typeof template.studiestedId === "function" ? (template.studiestedId as Function)(this) : template.studiestedId): this.generate("MinimalStudiestedDto", "studiestedId", "string", "47593db1-be0a-4c94-996e-cc3af946dcfc", false),
            institusjonsnr: template && template.institusjonsnr ? (typeof template.institusjonsnr === "function" ? (template.institusjonsnr as Function)(this) : template.institusjonsnr): this.generate("MinimalStudiestedDto", "institusjonsnr", "string", "1234", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("MinimalStudiestedDto", "navn", "string", "Universitetet i Oslo", false),
        };
    }
    sampleArrayMinimalStudiestedDto(template?: Factory<MinimalStudiestedDto>, length?: number): Array<MinimalStudiestedDto> {
        return Array.from({length: length || this.arrayLength("MinimalStudiestedDto")}).map(() => this.sampleMinimalStudiestedDto(template));
    }
    samplePraksisavtaleStedBestillingspunktTypeDto(template?: EnumFactory<PraksisavtaleStedBestillingspunktTypeDto>): PraksisavtaleStedBestillingspunktTypeDto {
        if (typeof this.sampleModelProperties["PraksisavtaleStedBestillingspunktTypeDto"] === "function") {
            return this.sampleModelProperties["PraksisavtaleStedBestillingspunktTypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                PraksisavtaleStedBestillingspunktTypeDto.AvtaleSted,
                PraksisavtaleStedBestillingspunktTypeDto.OmfattetAvtaleSted
        ]);
    }
    sampleArrayPraksisavtaleStedBestillingspunktTypeDto(template?: EnumFactory<PraksisavtaleStedBestillingspunktTypeDto>, length?: number): Array<PraksisavtaleStedBestillingspunktTypeDto> {
        return Array.from({length: length || this.arrayLength("PraksisavtaleStedBestillingspunktTypeDto")}).map(() => this.samplePraksisavtaleStedBestillingspunktTypeDto());
    }
    samplePraksisstedMedInfoDto(template?: Factory<PraksisstedMedInfoDto>): PraksisstedMedInfoDto {
        if (typeof this.sampleModelProperties["PraksisstedMedInfoDto"] === "function") {
            return this.sampleModelProperties["PraksisstedMedInfoDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("PraksisstedMedInfoDto", "id", "string", "null", false),
            navn: template && template.navn ? (typeof template.navn === "function" ? (template.navn as Function)(this) : template.navn): this.generate("PraksisstedMedInfoDto", "navn", "string", "Sykehus", false),
            kode: template && template.kode ? (typeof template.kode === "function" ? (template.kode as Function)(this) : template.kode): this.generate("PraksisstedMedInfoDto", "kode", "string", "null", false),
            eier: template && template.eier ? (typeof template.eier === "function" ? (template.eier as Function)(this) : template.eier): this.generate("PraksisstedMedInfoDto", "eier", "string", "null", false),
            statusAktiv: template && template.statusAktiv ? (typeof template.statusAktiv === "function" ? (template.statusAktiv as Function)(this) : template.statusAktiv): this.generate("PraksisstedMedInfoDto", "statusAktiv", "boolean", "null", false),
            nivaa: template && template.nivaa ? (typeof template.nivaa === "function" ? (template.nivaa as Function)(this) : template.nivaa): this.generate("PraksisstedMedInfoDto", "nivaa", "number", "1", false),
            relevant: template && template.relevant ? (typeof template.relevant === "function" ? (template.relevant as Function)(this) : template.relevant): this.generate("PraksisstedMedInfoDto", "relevant", "boolean", "null", false),
            praksisavtaler: template && template.praksisavtaler ? (typeof template.praksisavtaler === "function" ? (template.praksisavtaler as Function)(this) : template.praksisavtaler): this.generate("PraksisstedMedInfoDto", "praksisavtaler", "Array<MinimalPraksisavtaleDto>", "null", false),
            praksisbesvarelser: template && template.praksisbesvarelser ? (typeof template.praksisbesvarelser === "function" ? (template.praksisbesvarelser as Function)(this) : template.praksisbesvarelser): this.generate("PraksisstedMedInfoDto", "praksisbesvarelser", "Array<MinimalPraksisbesvarelseDto>", "null", false),
            praksisbestillinger: template && template.praksisbestillinger ? (typeof template.praksisbestillinger === "function" ? (template.praksisbestillinger as Function)(this) : template.praksisbestillinger): this.generate("PraksisstedMedInfoDto", "praksisbestillinger", "Array<MinimalPraksisbestillingDto>", "null", false),
            studentPraksisplasser: template && template.studentPraksisplasser ? (typeof template.studentPraksisplasser === "function" ? (template.studentPraksisplasser as Function)(this) : template.studentPraksisplasser): this.generate("PraksisstedMedInfoDto", "studentPraksisplasser", "Array<MinimalStudentPraksisplassDto>", "null", false),
            praksisstedtilganger: template && template.praksisstedtilganger ? (typeof template.praksisstedtilganger === "function" ? (template.praksisstedtilganger as Function)(this) : template.praksisstedtilganger): this.generate("PraksisstedMedInfoDto", "praksisstedtilganger", "Array<MinimalPraksisstedtilgangDto>", "null", false),
            undernoder: template && template.undernoder ? (typeof template.undernoder === "function" ? (template.undernoder as Function)(this) : template.undernoder): this.generate("PraksisstedMedInfoDto", "undernoder", "Array<PraksisstedMedInfoDto>", "null", false),
        };
    }
    sampleArrayPraksisstedMedInfoDto(template?: Factory<PraksisstedMedInfoDto>, length?: number): Array<PraksisstedMedInfoDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedMedInfoDto")}).map(() => this.samplePraksisstedMedInfoDto(template));
    }
    samplePraksisstedMedInfoOgHierarkiDto(template?: Factory<PraksisstedMedInfoOgHierarkiDto>): PraksisstedMedInfoOgHierarkiDto {
        if (typeof this.sampleModelProperties["PraksisstedMedInfoOgHierarkiDto"] === "function") {
            return this.sampleModelProperties["PraksisstedMedInfoOgHierarkiDto"](this);
        }

        return {
            selv: template && template.selv ? (typeof template.selv === "function" ? (template.selv as Function)(this) : template.selv): this.generate("PraksisstedMedInfoOgHierarkiDto", "selv", "PraksisstedMedInfoDto", "null", false),
            overnoder: template && template.overnoder ? (typeof template.overnoder === "function" ? (template.overnoder as Function)(this) : template.overnoder): this.generate("PraksisstedMedInfoOgHierarkiDto", "overnoder", "Array<PraksisstedMedInfoDto>", "null", false),
            undernoder: template && template.undernoder ? (typeof template.undernoder === "function" ? (template.undernoder as Function)(this) : template.undernoder): this.generate("PraksisstedMedInfoOgHierarkiDto", "undernoder", "Array<PraksisstedMedInfoDto>", "null", false),
        };
    }
    sampleArrayPraksisstedMedInfoOgHierarkiDto(template?: Factory<PraksisstedMedInfoOgHierarkiDto>, length?: number): Array<PraksisstedMedInfoOgHierarkiDto> {
        return Array.from({length: length || this.arrayLength("PraksisstedMedInfoOgHierarkiDto")}).map(() => this.samplePraksisstedMedInfoOgHierarkiDto(template));
    }
    sampleSynkroniseringsjobbDto(template?: Factory<SynkroniseringsjobbDto>): SynkroniseringsjobbDto {
        if (typeof this.sampleModelProperties["SynkroniseringsjobbDto"] === "function") {
            return this.sampleModelProperties["SynkroniseringsjobbDto"](this);
        }

        return {
            jobbtype: template && template.jobbtype ? (typeof template.jobbtype === "function" ? (template.jobbtype as Function)(this) : template.jobbtype): this.generate("SynkroniseringsjobbDto", "jobbtype", "string", "INSTITUSJON", false),
            nesteKjoring: template && template.nesteKjoring ? (typeof template.nesteKjoring === "function" ? (template.nesteKjoring as Function)(this) : template.nesteKjoring): this.generate("SynkroniseringsjobbDto", "nesteKjoring", "number", "1580143106014", false),
            sisteVellykket: template && template.sisteVellykket ? (typeof template.sisteVellykket === "function" ? (template.sisteVellykket as Function)(this) : template.sisteVellykket): this.generate("SynkroniseringsjobbDto", "sisteVellykket", "number", "1580143106014", false),
            antallFeil: template && template.antallFeil ? (typeof template.antallFeil === "function" ? (template.antallFeil as Function)(this) : template.antallFeil): this.generate("SynkroniseringsjobbDto", "antallFeil", "number", "0", false),
        };
    }
    sampleArraySynkroniseringsjobbDto(template?: Factory<SynkroniseringsjobbDto>, length?: number): Array<SynkroniseringsjobbDto> {
        return Array.from({length: length || this.arrayLength("SynkroniseringsjobbDto")}).map(() => this.sampleSynkroniseringsjobbDto(template));
    }
}
